import { render, staticRenderFns } from "./MaterialSelect.vue?vue&type=template&id=67285e44&"
import script from "./MaterialSelect.vue?vue&type=script&lang=js&"
export * from "./MaterialSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports